/* unplugin-vue-components disabled */import { render } from "./UserQuizzesResultsDialog.vue?vue&type=template&id=d26a6152&scoped=true&ts=true"
import script from "./UserQuizzesResultsDialog.vue?vue&type=script&lang=ts"
export * from "./UserQuizzesResultsDialog.vue?vue&type=script&lang=ts"

import "./UserQuizzesResultsDialog.vue?vue&type=style&index=0&id=d26a6152&scoped=true&lang=scss"
import "./UserQuizzesResultsDialog.vue?vue&type=style&index=1&id=d26a6152&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d26a6152"]])

export default __exports__